import teamMember from './teamMember';

export default {
	teamMemberPage: teamMember
}